import { SuccessComponent } from '@src/components/SuccessComponent';
import { useFormLogic } from '@src/hooks/useFormLogicWithReducer';
import { useContentFormValidation } from '@src/hooks/useFormValidation';
import { useNavigateToTop } from '@src/hooks/useNavigateToTop';
import { useCsrfFormSecurity } from '@src/plugins/cookies';

import { ContactForm } from './ContactForm';
import { ContactInfo } from './ContactInfo';

function Page({ children }) {
  return <div className="p-4">{children}</div>;
}

// 1. Unique Definitions
const CONTACT_INITIAL_STATE = {
  name: '',
  email: '',
  subject: '',
  message: '',
  recaptchaToken: '',
};
const CONTACT_ENDPOINT = 'api/v1/contacts/contact/submission/';

const nextStep = 1;
const scrollToTop = true;


export function ContactPage({ onNavigate }) {

  const csrfHookInfo = useCsrfFormSecurity();
  const onNavigateToTop = useNavigateToTop();


  // --- ONE SINGLE HOOK CALL replaces all state, inputs, mutation, and submission logic ---
  const {
    currentStep,
    recaptchaError,
    setRecaptchaError,
    setRecaptchaResetFunc,
    submissionError,
    submissionStatus,
    setSubmissionStatus,
    formData,
    handleInputChange,
    mutation,
    errors,
    handleSubmit,
    clearError,
  } = useFormLogic(
    CONTACT_INITIAL_STATE,
    CONTACT_ENDPOINT,
    useContentFormValidation,
    csrfHookInfo,
    nextStep,
    scrollToTop,
  );
  // --------------------------------------------------------------------------------------

  const { title, subtitle, nextSteps } = {
    title: 'Your Message Has Been Sent!',
    subtitle: 'Thanks for reaching out! Our team will get back to you shortly. We typically respond within one business day.',
    nextSteps: [
      'Check your email for confirmation',
      'Our team will review your message',
      'We\'ll respond within one business day',
    ],
  };

  return (
    <Page title="Contact Us" onNavigate={onNavigate}>
      <div className="flex flex-col md:flex-row gap-8 p-4 md:p-8 max-w-7xl mx-auto">
        {currentStep === 0 && (
          <ContactForm
            errors={errors}
            formData={formData}
            mutation={mutation}
            clearError={clearError}
            csrfHookInfo={csrfHookInfo}
            handleSubmit={handleSubmit}
            recaptchaError={recaptchaError}
            submissionError={submissionError}
            submissionStatus={submissionStatus}
            setRecaptchaError={setRecaptchaError}
            handleInputChange={handleInputChange}
            setSubmissionStatus={setSubmissionStatus}
            setRecaptchaResetFunc={setRecaptchaResetFunc}
            onNavigateToTop={onNavigateToTop}
          />
        )}

        {currentStep === 1 && (
          <SuccessComponent title={title} confetti={false} subtitle={subtitle} nextSteps={nextSteps} />
        )}

        <ContactInfo onNavigateToTop={onNavigateToTop} />
      </div>
    </Page>
  );
}
